"use strict";

import React, {
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";

import { AG_GRID_LOCALE_VN } from "@ag-grid-community/locale";
import {
  Box,
  Button,
  ComboboxItem,
  Flex,
  Grid,
  Group,
  rem,
  SegmentedControl,
  Select,
  Tabs,
} from "@mantine/core";
import { DatePickerInput } from "@mantine/dates";
import { useForm } from "@mantine/form";
import { useDisclosure } from "@mantine/hooks";
import {
  IconBrandBootstrap,
  IconBriefcase,
  IconBuildingStore,
  IconCalendarStats,
  IconChartBar,
  IconChartDonut3,
  IconFileExport,
  IconSearch,
  IconTable,
  IconTimeDuration15,
} from "@tabler/icons-react";
import { AgCharts } from "ag-charts-react";
import { AgChartOptions, AgBarSeriesOptions } from "ag-charts-enterprise";
import { ColDef, GridReadyEvent, ModuleRegistry } from "ag-grid-community";
import {
  IServerSideDatasource,
  IServerSideGetRowsRequest,
  ServerSideRowModelModule,
} from "ag-grid-enterprise";
import { AgGridReact } from "ag-grid-react";
import {
  paginationPageSize,
  paginationPageSizeSelector,
  repositoryMdm,
  repositoryPos,
} from "../../../_base/_const/_constVar";
import { NotificationExtension } from "../../../_base/extension/NotificationExtension";
import { SelectListItemBase } from "../../../_base/model/_base/SelectListItemBase";
import { formatPrice } from "../../../common/formatPrice/PriceFunction";
import LoadingOverlayCustom from "../../../common/LoadingOverLayCustom/LoadingOverLayCustom";
import { BASE_API_MDM } from "../../../config";
import { MessageResponse } from "../../../model/MessageResponse";
import { SaleByBranchModel } from "../../../model/SalesByBranchModel";
import { textAlign } from "html2canvas-pro/dist/types/css/property-descriptors/text-align";

ModuleRegistry.registerModules([ServerSideRowModelModule]);

const SalesByBranch = () => {
  const [loading, setLoading] = useState(true);
  const gridRef = useRef<AgGridReact<any>>(null);
  const datasourceRef = useRef<IServerSideDatasource | null>(null);
  const [totalRow, setTotalRow] = useState<SaleByBranchModel | null>(null);
  const [height, setHeight] = useState(800);
  const [heightChartBranchSearch, setHeightChartBranchSearch] =
    useState<string>("1400");
  const [dataBranchCode, setDataBranchCode] = useState<SelectListItemBase[]>(
    [],
  );
  const [dataDepartment, setDataDepartment] = useState<any[]>([]);
  const [selectedPeriod, setSelectedPeriod] = useState<string | null>(null);
  const [periodOptions, setPeriodOptions] = useState<
    { value: string; label: string }[]
  >([]);
  const headerRef = React.useRef<HTMLDivElement>(null);
  const [visible, { toggle, close, open }] = useDisclosure(false);

  // Chỗ này để làm lọc dùng form cho đỡ lag so với state
  const form = useForm<any>({
    initialValues: {
      KeySearch: null,
      // LoaiKy: "NGAY", // NGAY, THANG, QUY, NAM
      // LoaiKy: "NAM", // Đặt mặc định là "NAM"
      // TuNgay: formatLocalDate(new Date(new Date().getFullYear(), 0, 1)), // Ngày 01/01 của năm hiện tại
      // DenNgay: formatLocalDate(new Date(new Date().getFullYear(), 11, 31)), // Ngày 31/12 của năm hiện tại
      LoaiKy: "THANG", // Đặt mặc định là "NAM"
      TuNgay: formatLocalDate(
        new Date(new Date().getFullYear(), new Date().getMonth(), 1),
      ), // Ngày 01 của tháng hiện tại
      DenNgay: formatLocalDate(
        new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0),
      ), // Ngày cuối cùng của tháng hiện tại
      MaChiNhanh: null,
      SortBy: null, // Tên trường sắp xếp
      SortDirection: null, // ASC là tăng dần ,DESC là giảm dần
      GroupBy: "CN", // CN: Chi nhánh, BP: Bộ phận
      Tabs: "table", // table, chartColumn, chartPie
      TakeChartColumnBp: "32", //mặc định là 32
      MaBoPhan: null,
    },
  });

  function formatLocalDate(date: Date) {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  }

  // Vùng cho chart column
  const [chartData, setChartData] = useState<any[]>([]);
  console.log(chartData);
  const chartOptions = useMemo<AgChartOptions>(
    () => ({
      autoSize: true,
      theme: "ag-default",
      title: {
        text: `Tổng doanh thu theo ${
          form.getValues().GroupBy === "CN" ? "chi nhánh" : "bộ phận"
        }`,
        fontSize: 22,
        color: "#000",
      },
      subtitle: {
        text: `Doanh thu và số lượng đơn hàng ${
          form.getValues().GroupBy === "BP" &&
          form.getValues().Tabs === "chartColumn" &&
          form.getValues().TakeChartColumnBp === "32"
            ? "(32 bộ phận có danh thu cao nhất)"
            : ""
        }`,
        color: "#000",
      },
      data: chartData,
      series: [
        {
          type: "bar" as const,
          direction: "horizontal", // QUAN TRỌNG: Chuyển thành biểu đồ thanh ngang
          xKey: "branch", // Trục X (Category) vẫn là tên chi nhánh
          yKey: "revenue", // Trục Y (Value) vẫn là doanh thu
          yName: "Doanh thu",
          fill: "#4dabf7", // Màu xanh dương nhạt như hình mẫu
          stroke: "#228be6",
          cornerRadius: 4,
          // --- CẤU HÌNH NHÃN (LABEL) ---
          label: {
            enabled: true,
            color: "#000", // Màu chữ đen cho dễ đọc trên nền trắng
            fontSize: 13,
            placement: "outside-end",
            formatter: ({ value }: any) => formatPrice(value),
            marginLeft: 10,
          },
        },
      ],
      axes: [
        {
          type: "category",
          position: "left", // QUAN TRỌNG: Tên chi nhánh nằm bên trái
          // title: { text: 'Chi nhánh', color: '#fff' },
          label: {
            color: "#000",
            maxWidth: 500,
            width: 500,
            autoRotate: false,
          },
        },
        {
          type: "number",
          position: "bottom", // QUAN TRỌNG: Trục số tiền nằm bên dưới
          title: { text: "Doanh thu (VNĐ)", color: "#000" },
          label: {
            formatter: (params: any) => formatPrice(params.value),
            color: "#000",
          },
          gridLine: {
            style: [{ stroke: "#2c3340", lineDash: [4, 4] }],
          },
        },
      ],
      legend: { enabled: false },
      padding: { top: 20, right: 60, bottom: 20, left: 20 }, // Tăng padding phải để số liệu không bị cắt
    }),
    [chartData],
  );

  // Vùng cho Pie (sơ đồ hình tròn)
  const pieOptions = useMemo<AgChartOptions>(
    () => ({
      autoSize: true,
      theme: "ag-default",
      title: {
        text: `Tỷ trọng doanh thu theo ${
          form.getValues().GroupBy === "CN" ? "chi nhánh" : "bộ phận"
        }`,
        fontSize: 22,
        color: "#000",
      },
      subtitle: {
        text: "Doanh thu và số lượng đơn hàng",
        color: "#000",
      },

      data: chartData,
      series: [
        {
          type: "pie",
          angleKey: "revenue",
          legendItemKey: "branch", // Dùng branch làm key cho legend
          calloutLabelKey: "branch", // Dùng branch làm nhãn hiển thị ra ngoài
          sectorLabelKey: "revenue",
          calloutLabel: {
            enabled: true,
            color: "#000",
            fontSize: 12,
            offset: 10,
          },
          sectorLabel: {
            formatter: ({ value }: any) => formatPrice(value),
          },
          calloutLine: {
            strokeWidth: 1,
            colors: ["#000"],
          },
          // Tooltip hiển thị số tiền đã format khi hover
          tooltip: {
            renderer: ({ datum }: any) =>
              `${datum.branch} — ${formatPrice(datum.revenue)}`,
          },
        },
      ],
      // Configuration for highlighting items
      highlightStyle: {
        item: {
          strokeWidth: 5,
        },
        series: {
          opacity: 0.2,
        },
      },
      legend: {
        position: "bottom",
        item: {
          label: {
            color: "#000",
          },
          paddingX: 20,
        },
      },
      // legend: {
      //   position: 'bottom',
      //   item: {
      //     label: {
      //       color: '#000',
      //       formatter: ({ datum, data }: any) => {
      //         console.log("Loggdataa", data);
      //         console.log("Loggdatum", datum);
      //         // Tính tổng revenue
      //         const total = data.reduce((sum: number, d: any) => sum + (d.revenue || 0), 0);
      //         const percent = total ? ((datum.revenue / total) * 100).toFixed(1) : 0;
      //         return `${datum.branch} (${formatPrice(datum.revenue)} = ${percent}%)`;
      //       },
      //     },
      //     paddingX: 20,
      //   },
      // },
      padding: { top: 20, right: 20, bottom: 20, left: 20 },
    }),
    [chartData],
  );
  const containerStyle = useMemo(
    () => ({ width: "100%", height: `${height}px` }),
    [height],
  );
  const gridStyle = useMemo(
    () => ({ height: `${height + 90}px `, width: "100%" }),
    [height],
  );
  const sizeGrid = { base: 6, sm: 3, md: 3, lg: 2, xl: 1.7 };

  useEffect(() => {
    const updateHeight = () => {
      const headerHeight = headerRef.current?.offsetHeight || 0;
      // 400 là tổng khoảng cách cần trừ (breadcrumb, filters, padding, pagination)
      const newHeight = window.innerHeight - (210 + headerHeight);
      setHeight(newHeight);
    };

    // Đợi DOM render xong rồi mới tính
    setTimeout(updateHeight, 0);
    window.addEventListener("resize", updateHeight);

    return () => {
      window.removeEventListener("resize", updateHeight);
    };
  }, []);

  // Hàm tự động set ngày theo loại kỳ
  const handleLoaiKyChange = useCallback(
    (value: string | null) => {
      form.setFieldValue("LoaiKy", value ?? "NGAY");
      setSelectedPeriod(null); // Reset selected period when LoaiKy changes

      const now = new Date();
      let tuNgay: Date;
      let denNgay: Date;
      let options: { value: string; label: string }[] = [];

      switch (value) {
        case "NGAY":
          tuNgay = now;
          denNgay = now;
          break;

        case "THANG":
          // Populate months for the current year
          for (let i = 0; i < 12; i++) {
            options.push({ value: String(i + 1), label: `Tháng ${i + 1}` });
          }
          setPeriodOptions(options);
          tuNgay = new Date(now.getFullYear(), now.getMonth(), 1);
          denNgay = new Date(now.getFullYear(), now.getMonth() + 1, 0);
          setSelectedPeriod(String(now.getMonth() + 1));
          break;

        case "QUY":
          // Populate quarters
          options.push(
            { value: "1", label: "Quý 1 (Tháng 1-3)" },
            { value: "2", label: "Quý 2 (Tháng 4-6)" },
            { value: "3", label: "Quý 3 (Tháng 7-9)" },
            { value: "4", label: "Quý 4 (Tháng 10-12)" },
          );
          setPeriodOptions(options);
          const currentMonth = now.getMonth();
          const quarter = Math.floor(currentMonth / 3) + 1;
          setSelectedPeriod(String(quarter));
          const quarterStartMonth = (quarter - 1) * 3;
          tuNgay = new Date(now.getFullYear(), quarterStartMonth, 1);
          denNgay = new Date(now.getFullYear(), quarterStartMonth + 3, 0);
          break;

        case "NAM":
          // Populate years (e.g., current year and past 5 years)
          for (let i = 0; i < 5; i++) {
            const year = now.getFullYear() - i;
            options.push({ value: String(year), label: `Năm ${year}` });
          }
          setPeriodOptions(options);
          tuNgay = new Date(now.getFullYear(), 0, 1);
          denNgay = new Date(now.getFullYear(), 11, 31);
          setSelectedPeriod(String(now.getFullYear()));
          break;

        default:
          tuNgay = now;
          denNgay = now;
      }

      form.setFieldValue("TuNgay", formatLocalDate(tuNgay));
      form.setFieldValue("DenNgay", formatLocalDate(denNgay));
    },
    [form],
  );

  const handlePeriodSelectChange = useCallback(
    (value: string | null) => {
      setSelectedPeriod(value);
      const loaiKy = form.getValues().LoaiKy;
      const now = new Date();
      let tuNgay: Date;
      let denNgay: Date;

      if (!value) return;

      switch (loaiKy) {
        case "THANG":
          const month = parseInt(value, 10) - 1; // months are 0-indexed
          tuNgay = new Date(now.getFullYear(), month, 1);
          denNgay = new Date(now.getFullYear(), month + 1, 0);
          break;
        case "QUY":
          const quarter = parseInt(value, 10);
          const quarterStartMonth = (quarter - 1) * 3;
          tuNgay = new Date(now.getFullYear(), quarterStartMonth, 1);
          denNgay = new Date(now.getFullYear(), quarterStartMonth + 3, 0);
          break;
        case "NAM":
          const year = parseInt(value, 10);
          tuNgay = new Date(year, 0, 1);
          denNgay = new Date(year, 11, 31);
          break;
        default:
          return;
      }

      form.setFieldValue("TuNgay", formatLocalDate(tuNgay));
      form.setFieldValue("DenNgay", formatLocalDate(denNgay));
    },
    [form],
  );

  // Lấy danh sách chi nhánh
  const fetchBranchCode = async () => {
    try {
      const response = await repositoryPos.get<
        MessageResponse<SelectListItemBase[]>
      >(`api/v1/TblDmInventory/get-select-branch?auth=true`);
      if (response && response.success) {
        const data = response.data;
        setDataBranchCode(data);
      }
    } catch (error) {
      console.error(error);
      return;
    }
  };

  const getDataDepartment = async () => {
    const res = await repositoryPos.get<MessageResponse<any>>(
      "/api/v1/TblDepartment/get-select",
    );

    if (res && res.success) {
      const mappedData =
        res?.data
          ?.filter((i: any) => i.text && i.att1)
          .map((i: any) => ({
            label: String(i.text),
            value: String(i.att1),
          })) || [];

      const uniqueData = [
        ...new Map(mappedData.map((item: any) => [item.value, item])).values(),
      ];

      setDataDepartment(uniqueData);
    }
  };

  const fetchData = async (request: IServerSideGetRowsRequest) => {
    // console.log("[fetchData] called at", new Date().toISOString());
    // console.log("[fetchData] request:", request);
    // console.log("[fetchData] form.getValues():", form.getValues());
    // console.log("[fetchData] Tabs:", form.getValues().Tabs, "GroupBy:", form.getValues().GroupBy);
    // console.log("LoggTabs:", form.getValues().Tabs, "GroupBy:", form.getValues().GroupBy);
    open();
    try {
      // Lấy page size hiện tại từ grid API
      const currentPageSize =
        gridRef.current?.api?.paginationGetPageSize() || paginationPageSize;
      const skip = request.startRow || 0;
      const take = currentPageSize;

      const keySearch = {
        KeySearch: form.getValues().KeySearch || "",
        LoaiKy: form.getValues().LoaiKy || "",
        TuNgay: form.getValues().TuNgay || "",
        DenNgay: form.getValues().DenNgay || "",
        MaChiNhanh:
          form.getValues().GroupBy === "CN"
            ? form.getValues().MaChiNhanh || ""
            : "",
        MaBoPhan:
          form.getValues().GroupBy === "BP"
            ? form.getValues().MaBoPhan || ""
            : "",
        // SortBy: form.getValues().SortBy || "",
        // SortDirection: form.getValues().SortDirection || "",
        GroupBy: form.getValues().GroupBy,
        SortBy:
          form.getValues().GroupBy === "BP" &&
          form.getValues().Tabs === "chartColumn"
            ? "saU_CK_GG_KY_NAY"
            : form.getValues().GroupBy === "CN" &&
                form.getValues().Tabs === "chartColumn"
              ? "saU_CK_GG_KY_NAY"
              : form.getValues().GroupBy === "CN"
                ? "mA_CHI_NHANH"
                : form.getValues().SortBy || "",
        SortDirection:
          form.getValues().GroupBy === "BP" &&
          form.getValues().Tabs === "chartColumn"
            ? "DESC"
            : form.getValues().GroupBy === "CN" &&
                form.getValues().Tabs === "chartColumn"
              ? "DESC"
              : form.getValues().GroupBy === "CN"
                ? "ASC"
                : form.getValues().SortDirection || "",
      };
      const takeCustom =
        form.getValues().GroupBy === "BP" &&
        form.getValues().Tabs === "chartColumn"
          ? form.getValues().TakeChartColumnBp
          : take;
      let url = `/api/v1/BaoCaoBanHangChiNhanh/get-list?Skip=${skip}&Take=${takeCustom}`;
      Object.entries(keySearch).forEach(([key, value]) => {
        if (value) {
          url += `&${key}=${encodeURIComponent(value)}`;
        }
      });

      // console.log("API URL:", url, "Skip:", skip, "Take:", take, "PageSize:", currentPageSize);
      return await repositoryMdm.get<MessageResponse<SaleByBranchModel[]>>(url);
    } catch (error) {
      console.error(error);
    } finally {
      close();
    }
  };
  // Call api bên server
  const getServerSideDatasource = useCallback((): IServerSideDatasource => {
    return {
      getRows: async (params) => {
        var response = await fetchData(params.request);
        // let response = { success: true, data: FAKE_DATA, totalCount: FAKE_DATA.length }; // Sử dụng dữ liệu giả để test
        // adding delay to simulate real server call
        if (response && response.success) {
          // Tách row TOTAL ra khỏi data chính
          const allData = response.data || [];
          const totalRowData = allData.find((row) => row.ma_Code === "TOTAL");
          const normalRows = allData.filter((row) => row.ma_Code !== "TOTAL");
          // const totalRevenue = allData.filter(r => r.ma_Code === "TOTAL")[0]?.doanH_THU_KY_NAY;
          // const totalRevenue = totalRowData?.doanH_THU_KY_NAY || 0;
          const totalRevenue = totalRowData?.saU_CK_GG_KY_NAY || 0; //Lấy theo trường này

          // CẬP NHẬT PHẦN NÀY: Map thêm trường 'orders'
          const chartRows = allData
            .filter((r) => r.ma_Code !== "TOTAL")
            .map((r) => {
              const branch = (r.ten_Name || "").replace("HACOM - ", "");
              // const revenue = r.doanH_THU_KY_NAY || 0;
              const revenue = r.saU_CK_GG_KY_NAY || 0; //Dùng trường này nhé , theo yêu cầu chứ k lấy theo doanh thu kỳ này
              const percent = totalRevenue
                ? ((revenue / totalRevenue) * 100).toFixed(1)
                : 0;
              return {
                branch: `${branch} (${percent}%)`,
                // branch: `${branch}`,
                revenue,
                orders: r.sO_LUONG_DON_HANG_KY_NAY || 0,
                // legend field sẽ hiển thị tên + số tiền đã format trong legend bên phải
                legend: `${branch} (${formatPrice(revenue)} = ${percent}%)`,
              };
            });

          setChartData(chartRows);

          //Xử lý chiều cao biểu đồ cột khi lọc chi nhánh
          if (
            (form.getValues().GroupBy === "BP" && form.getValues().MaBoPhan) ||
            (form.getValues().GroupBy === "CN" && form.getValues().MaChiNhanh)
          ) {
            setHeightChartBranchSearch("225");
          } else {
            setHeightChartBranchSearch("1400");
          }

          // Lưu TOTAL row vào state
          if (totalRowData) {
            setTotalRow(totalRowData);
          }

          params.success({
            rowData: normalRows,
            rowCount: (response as any).totalCount ?? normalRows.length,
          });
          setLoading(false);
        } else {
          // inform the grid request failed
          params.fail();
          setLoading(false);
        }
      },
    };
  }, [
    form.getValues().Tabs,
    form.getValues().GroupBy,
    form.getValues().TakeChartColumnBp,
    form.getValues().MaChiNhanh,
  ]);

  // đảm bảo refresh dữ liệu khi user chuyển tab (để fetchData dùng đúng activeTab)
  useEffect(() => {
    // chỉ reload khi grid đã sẵn sàng
    if (gridRef.current?.api) {
      gridRef.current.api.refreshServerSide?.({ purge: true });
    }
  }, [form.getValues().Tabs, form.getValues().GroupBy]);
  // Sau khi chọn tìm kiếm xong thì sẽ thực hiện click để call api này
  const handleSearch = useCallback(() => {
    console.log("Search clicked with values:", form.getValues());
    setLoading(true);
    const api = gridRef.current?.api;
    if (!api) {
      console.log("API not ready");
      return;
    }

    // Refresh server-side cache để gọi lại getRows với filter mới
    (api as any).refreshServerSide({ purge: true });
  }, []);

  const onGridReady = useCallback(
    (params: GridReadyEvent) => {
      // đăng datasource đúng để ag-Grid gọi getRows
      const datasource = getServerSideDatasource();
      datasourceRef.current = datasource;
      params.api.setGridOption("serverSideDatasource", datasource);
      console.log("Grid ready, datasource registered");
    },
    [getServerSideDatasource],
  );

  const getRowId = useCallback((params: any) => {
    return params.data?.mA_CHI_NHANH || Math.random().toString();
  }, []);

  const getRowStyle = useCallback((params: any) => {
    if (params.node.rowPinned) {
      return {
        backgroundColor: "#e7f5ff",
        fontWeight: 700,
        fontSize: "14px",
        borderTop: "3px solid #15aabf",
      };
    }
    return undefined;
  }, []);

  // Hàm sửa lý sự kiện sắp xếp
  const handleSortChanged = useCallback(() => {
    const columnState = gridRef.current?.api?.getColumnState() || [];
    console.log("LogggcolumnState", columnState);
    // tìm cột có sort (asc/desc)
    const sortedCol = columnState.find((c: any) => c.sort);
    if (sortedCol) {
      form.setFieldValue("SortBy", sortedCol.colId);
      form.setFieldValue(
        "SortDirection",
        (sortedCol.sort || "").toUpperCase() === "ASC" ? "ASC" : "DESC",
      );
    } else {
      form.setFieldValue("SortBy", null);
      form.setFieldValue("SortDirection", null);
    }
    // reload server-side data với sort mới
    gridRef.current?.api?.refreshServerSide?.({ purge: true });
  }, [form]);

  const columnDefs = useMemo<ColDef[]>(
    () => [
      {
        field: "ma_Code",
        headerName: form.getValues().GroupBy === "CN" ? "Mã CN" : "Mã BP",
        width: 100,
      },
      {
        field: "ten_Name",
        headerName:
          form.getValues().GroupBy === "CN" ? "Tên chi nhánh" : "Tên bộ phận",
        width: 220,
      },
      {
        field: "sO_LUONG_DON_HANG_KY_NAY",
        headerName: "SL đơn (Kỳ này)",
        width: 160,
        valueFormatter: (p) => (p.value != null ? p.value : ""),
      },
      {
        field: "doanH_THU_KY_NAY",
        headerName: "Doanh thu (Kỳ này)",
        width: 200,
        valueFormatter: (p) => (p.value != null ? formatPrice(p.value) : ""),
      },
      {
        field: "giaM_GIA_KY_NAY",
        headerName: "Giảm giá (Kỳ này)",
        width: 180,
        valueFormatter: (p) => (p.value != null ? formatPrice(p.value) : ""),
      },
      {
        field: "chieT_KHAU_KY_NAY",
        headerName: "Chiết khấu (Kỳ này)",
        width: 180,
        valueFormatter: (p) => (p.value != null ? formatPrice(p.value) : ""),
      },
      {
        field: "saU_CK_GG_KY_NAY",
        headerName: "Sau CK/GG (Kỳ này)",
        width: 200,
        valueFormatter: (p) => (p.value != null ? formatPrice(p.value) : ""),
      },
      {
        field: "tieN_VON_KY_NAY",
        headerName: "Tiền vốn (Kỳ này)",
        width: 200,
        valueFormatter: (p) => (p.value != null ? formatPrice(p.value) : ""),
      },
      {
        field: "tieN_LAI_KY_NAY",
        headerName: "Tiền lãi (Kỳ này)",
        width: 200,
        valueFormatter: (p) => (p.value != null ? formatPrice(p.value) : ""),
      },

      {
        field: "sO_LUONG_DON_HANG_KY_TRUOC",
        headerName: "SL đơn (Kỳ trước)",
        width: 150,
        valueFormatter: (p) => (p.value != null ? formatPrice(p.value) : ""),
      },
      {
        field: "doanH_THU_KY_TRUOC",
        headerName: "Doanh thu (Kỳ trước)",
        width: 200,
        valueFormatter: (p) => (p.value != null ? formatPrice(p.value) : ""),
      },
      {
        field: "giaM_GIA_KY_TRUOC",
        headerName: "Giảm giá (Kỳ trước)",
        width: 180,
        valueFormatter: (p) => (p.value != null ? formatPrice(p.value) : ""),
      },
      {
        field: "chieT_KHAU_KY_TRUOC",
        headerName: "Chiết khấu (Kỳ trước)",
        width: 180,
        valueFormatter: (p) => (p.value != null ? formatPrice(p.value) : ""),
      },
      {
        field: "saU_CK_GG_KY_TRUOC",
        headerName: "Sau CK/GG (Kỳ trước)",
        width: 200,
        valueFormatter: (p) => (p.value != null ? formatPrice(p.value) : ""),
      },
      {
        field: "tieN_VON_KY_TRUOC",
        headerName: "Tiền vốn (Kỳ trước)",
        width: 200,
        valueFormatter: (p) => (p.value != null ? formatPrice(p.value) : ""),
      },
      {
        field: "tieN_LAI_KY_TRUOC",
        headerName: "Tiền lãi (Kỳ trước)",
        width: 200,
        valueFormatter: (p) => (p.value != null ? formatPrice(p.value) : ""),
      },
    ],
    [form.values.GroupBy],
  );

  const defaultColDef = useMemo<ColDef>(() => {
    return {
      sortable: true,
      resizable: true,
    };
  }, []);

  const exportDataExcel = async () => {
    open(); // Hiển thị loading
    try {
      // // Lấy page hiện tại / pageSize giống fetchData
      const currentPageSize =
        gridRef.current?.api?.paginationGetPageSize() || paginationPageSize;
      const currentPage =
        gridRef.current?.api?.paginationGetCurrentPage?.() || 0;
      const skip = currentPage * currentPageSize;
      const take = currentPageSize;

      const keySearch = {
        KeySearch: form.getValues().KeySearch || "",
        LoaiKy: form.getValues().LoaiKy || "",
        TuNgay: form.getValues().TuNgay || "",
        DenNgay: form.getValues().DenNgay || "",
        MaChiNhanh:
          form.getValues().GroupBy === "CN"
            ? form.getValues().MaChiNhanh || ""
            : "",
        MaBoPhan:
          form.getValues().GroupBy === "BP"
            ? form.getValues().MaBoPhan || ""
            : "",
        // SortBy: form.getValues().SortBy || "",
        // SortDirection: form.getValues().SortDirection || "",
        GroupBy: form.getValues().GroupBy,
        SortBy:
          form.getValues().GroupBy === "BP" &&
          form.getValues().Tabs === "chartColumn"
            ? "doanH_THU_KY_NAY"
            : form.getValues().GroupBy === "CN" &&
                form.getValues().Tabs === "chartColumn"
              ? "doanH_THU_KY_NAY"
              : form.getValues().GroupBy === "CN"
                ? "mA_CHI_NHANH"
                : form.getValues().SortBy || "",
        SortDirection:
          form.getValues().GroupBy === "BP" &&
          form.getValues().Tabs === "chartColumn"
            ? "DESC"
            : form.getValues().GroupBy === "CN" &&
                form.getValues().Tabs === "chartColumn"
              ? "DESC"
              : form.getValues().GroupBy === "CN"
                ? "ASC"
                : form.getValues().SortDirection || "",
      };

      let url = `/api/v1/BaoCaoBanHangChiNhanh/export-bao-cao-ban-hang-theo-chi-nhanh?Skip=${skip}&Take=${take}`;
      Object.entries(keySearch).forEach(([key, value]) => {
        if (value) {
          url += `&${key}=${encodeURIComponent(value)}`;
        }
      });
      const _url = BASE_API_MDM + url;
      const fullUrl = new URL(_url);
      const token = localStorage.getItem("token");

      // Gọi API
      const response = await fetch(fullUrl.toString(), {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token?.replace(/"/g, "")}`,
          "Content-Type": "application/vnd.ms-excel",
        },
      });
      // Kiểm tra trạng thái HTTP
      if (!response.ok) {
        const errorResponse = await response.json(); // Parse lỗi từ API
        const errorMessage =
          errorResponse?.message || "Đã xảy ra lỗi khi xuất dữ liệu!";
        throw new Error(errorMessage); // Ném lỗi để xử lý trong `catch`
      }

      // Xử lý file Excel
      const blob = await response.blob();
      const blobUrl = window.URL.createObjectURL(blob);
      const filename = "bao_cao_ban_hang_theo_chi_nhanh.xlsx"; // Tên mặc định nếu không có header
      const link = document.createElement("a");
      link.href = blobUrl;
      link.download = filename;
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(blobUrl);
    } catch (error: any) {
      console.error("Error:", error);
      // Hiển thị thông báo lỗi
      NotificationExtension.Fails(
        error.message || "Đã xảy ra lỗi không xác định!",
      );
    } finally {
      close(); // Đóng loading
    }
  };

  // Cho hình cột
  const ChartColumnRef = useRef<HTMLDivElement>(null);
  // Cho hình tròn
  const ChartPieRef = useRef<HTMLDivElement>(null);
  //#region Download Image
  const handleDownloadImage = async (
    refCurrent: React.RefObject<HTMLDivElement>,
  ) => {
    const html2canvas = await import("html2canvas-pro");

    if (!refCurrent.current) {
      console.error("Error: refCurrent is null.");
      return;
    }

    // setIsLoading(true);
    open(); // Hiển thị loading

    try {
      // 🚀 TRICK 1: Pre-optimize DOM trước khi capture
      const element = refCurrent.current;

      // Set fixed size để html2canvas xử lý nhanh hơn
      const originalStyle = element.style.cssText;
      element.style.width = `${element.scrollWidth}px`;
      element.style.transform = "scale(1)";
      element.style.transformOrigin = "top left";

      // 🚀 TRICK 2: Hide unnecessary elements
      const unnecessaryElements = element.querySelectorAll(
        "button, .fa-solid, .fa-regular, svg",
      );
      const hiddenElements: HTMLElement[] = [];
      unnecessaryElements.forEach((el: any) => {
        if (el.style.display !== "none") {
          hiddenElements.push(el);
          el.style.display = "none";
        }
      });

      // 🚀 TRICK 3: Html2canvas với settings tối ưu tối đa
      const canvas = await html2canvas.default(element, {
        scale: 1, // 🔥 Key optimization: scale = 1
        useCORS: true,
        allowTaint: false,
        backgroundColor: "#ffffff",
        width: element.scrollWidth,
        logging: false,
        imageTimeout: 1000, // 🔥 Giảm timeout
        removeContainer: false,
        foreignObjectRendering: false,
        ignoreElements: (element) => {
          // 🔥 Skip heavy elements
          return (
            element.tagName === "BUTTON" ||
            element.tagName === "SVG" ||
            element.classList.contains("fa-solid") ||
            element.classList.contains("fa-regular")
          );
        },
      });

      // 🚀 TRICK 4: Restore DOM ngay lập tức
      element.style.cssText = originalStyle;
      hiddenElements.forEach((el) => {
        el.style.display = "";
      });

      // 🚀 TRICK 5: Generate filename nhanh
      const now = new Date();
      const fileName = `Bieu-Do-${
        form.getValues().GroupBy === "BP" ? "Bo-Phan" : "Chi-Nhanh"
      }-${
        form.getValues().Tabs === "chartColumn" ? "hinh-Cot" : "hinh-Tron"
      }-${String(now.getDate()).padStart(2, "0")}-${String(
        now.getMonth() + 1,
      ).padStart(2, "0")}-${String(now.getHours()).padStart(2, "0")}-${String(
        now.getMinutes(),
      ).padStart(2, "0")}`;

      // 🚀 TRICK 6: Download trực tiếp bằng toBlob (nhanh nhất)
      canvas.toBlob(
        (blob) => {
          if (blob) {
            const url = URL.createObjectURL(blob);
            const link = document.createElement("a");
            link.href = url;
            link.download = `${fileName}.jpg`;
            link.click();
            URL.revokeObjectURL(url);
            NotificationExtension.Success("Tải ảnh thành công!");
          }
        },
        "image/jpeg",
        0.85,
      );
    } catch (error) {
      console.error("Error generating image:", error);
      NotificationExtension.Fails("Tải ảnh thất bại!");
    } finally {
      // setIsLoading(false);
      close(); // Đóng loading
    }
  };

  useEffect(() => {
    Promise.all([fetchBranchCode(), getDataDepartment()]);
  }, []);

  return (
    <Box pos={"relative"} style={containerStyle}>
      <LoadingOverlayCustom visible={visible} />
      <div
        ref={headerRef}
        style={{
          border: "1px solid #dee2e6",
          padding: "5px 10px",
          overflowX: "hidden",
        }}
      >
        <Group justify="space-between">
          {/* <BreadcrumbLayout1></BreadcrumbLayout1> */}
          <div>
            <SegmentedControl
              value={form.values.GroupBy}
              onChange={(v) => {
                form.setFieldValue("GroupBy", v);
                setLoading(true);
                // reload data theo loại mới
                gridRef.current?.api?.refreshServerSide?.({ purge: true });
              }}
              data={[
                { label: "Theo chi nhánh", value: "CN" },
                { label: "Theo bộ phận", value: "BP" },
              ]}
              size="md"
              color="teal"
              radius="sm"
              styles={{ root: { minWidth: 220 } }}
            />
          </div>
          <Button
            leftSection={
              <IconFileExport style={{ width: rem(14), height: rem(14) }} />
            }
            onClick={() => {
              exportDataExcel();
            }}
          >
            Export Excel
          </Button>
        </Group>
      </div>
      <Tabs
        value={form.getValues().Tabs}
        onChange={(value) => {
          form.setFieldValue("Tabs", value);
          setLoading(true);
          // reload data theo loại mới
          gridRef.current?.api?.refreshServerSide?.({ purge: true });
        }}
      >
        <Flex justify={"space-between"} style={{ marginBottom: 12 }}>
          <Group align="end" flex={"1"} wrap="wrap">
            <Grid style={{ width: "100%" }} mt={10}>
              {/* <Grid.Col span={sizeGrid}>
              <Input placeholder="Từ khoá"
                leftSection={<IconSearch color="#15aabf" />}
                key={form.key("keySearch")}
                {...form.getInputProps("KeySearch")} />
            </Grid.Col> */}
              <Grid.Col span={sizeGrid}>
                <Select
                  size="sm"
                  placeholder="Chọn loại kỳ"
                  leftSection={<IconCalendarStats size={20} color="#15aabf" />}
                  data={[
                    { value: "NGAY", label: "Ngày" },
                    { value: "THANG", label: "Tháng" },
                    { value: "QUY", label: "Quý" },
                    { value: "NAM", label: "Năm" },
                  ]}
                  {...form.getInputProps("LoaiKy")}
                  onChange={handleLoaiKyChange}
                  styles={{
                    input: {
                      fontWeight: 600,
                      borderColor: "#15aabf",
                      borderWidth: "2px",
                    },
                  }}
                />
              </Grid.Col>
              {form.values.LoaiKy !== "NGAY" && (
                <Grid.Col span={sizeGrid}>
                  <Select
                    size="sm"
                    placeholder={
                      form.values.LoaiKy === "THANG"
                        ? "Chọn tháng"
                        : form.values.LoaiKy === "QUY"
                          ? "Chọn quý"
                          : "Chọn năm"
                    }
                    leftSection={
                      <IconCalendarStats size={20} color="#15aabf" />
                    }
                    data={periodOptions}
                    value={selectedPeriod}
                    onChange={handlePeriodSelectChange}
                    styles={{
                      input: {
                        fontWeight: 600,
                        borderColor: "#15aabf",
                        borderWidth: "2px",
                      },
                    }}
                  />
                </Grid.Col>
              )}
              <Grid.Col span={sizeGrid}>
                <DatePickerInput
                  value={
                    form.values.TuNgay ? new Date(form.values.TuNgay) : null
                  }
                  onChange={(d) =>
                    form.setFieldValue(
                      "TuNgay",
                      d
                        ? new Date(
                            new Date(d).getTime() + 7 * 3600 * 1000,
                          ).toISOString()
                        : null,
                    )
                  }
                  placeholder="Từ ngày"
                  clearable
                  size="sm"
                  locale="vi"
                  valueFormat="DD/MM/YYYY"
                  leftSection={<IconTimeDuration15 size={20} color="#15aabf" />}
                  styles={{
                    input: {
                      fontWeight: 600,
                      borderColor: "#15aabf",
                      borderWidth: "2px",
                    },
                  }}
                />
              </Grid.Col>
              <Grid.Col span={sizeGrid}>
                <DatePickerInput
                  value={
                    form.values.DenNgay ? new Date(form.values.DenNgay) : null
                  }
                  onChange={(d) =>
                    form.setFieldValue(
                      "DenNgay",
                      d
                        ? new Date(
                            new Date(d).getTime() + 7 * 3600 * 1000,
                          ).toISOString()
                        : null,
                    )
                  }
                  placeholder="Đến ngày"
                  clearable
                  size="sm"
                  locale="vi"
                  valueFormat="DD/MM/YYYY"
                  leftSection={<IconTimeDuration15 size={20} color="#15aabf" />}
                  styles={{
                    input: {
                      fontWeight: 600,
                      borderColor: "#15aabf",
                      borderWidth: "2px",
                    },
                  }}
                />
              </Grid.Col>
              {form.getValues().GroupBy === "BP" ? (
                <Grid.Col span={sizeGrid}>
                  <Select
                    key={form.key("MaBoPhan")}
                    placeholder="Bộ phận"
                    size="sm"
                    leftSection={<IconBriefcase color="#15aabf" />}
                    searchable
                    clearable
                    data={dataDepartment}
                    nothingFoundMessage="Không tìm thấy dữ liệu !"
                    styles={{
                      input: {
                        fontWeight: 600,
                        borderColor: "#15aabf",
                        borderWidth: "2px",
                      },
                    }}
                    {...form.getInputProps("MaBoPhan")}
                  />
                </Grid.Col>
              ) : (
                <Grid.Col span={sizeGrid}>
                  <Select
                    size="sm"
                    leftSection={<IconBrandBootstrap color="#15aabf" />}
                    searchable
                    clearable
                    placeholder="Chi nhánh"
                    data={dataBranchCode
                      .filter((ele) => ele.att2 && ele.text)
                      .map((ele) => ({
                        label: ele.att2 + " - " + ele.text,
                        value: ele.att2,
                      }))}
                    key={form.key("MaChiNhanh")}
                    {...form.getInputProps("MaChiNhanh")}
                    styles={{
                      input: {
                        fontWeight: 600,
                        borderColor: "#15aabf",
                        borderWidth: "2px",
                      },
                    }}
                  />
                </Grid.Col>
              )}
              <Grid.Col span={sizeGrid}>
                <Button
                  leftSection={<IconSearch size={20} />}
                  color="blue"
                  variant="filled"
                  onClick={handleSearch}
                  styles={{
                    root: {
                      fontWeight: 600,
                    },
                  }}
                >
                  Tìm kiếm
                </Button>
              </Grid.Col>
            </Grid>
          </Group>
          <Group>
            <Tabs.List>
              {/* Biểu đồ hình cột */}
              <Tabs.Tab value="chartColumn">
                <IconChartBar size={24} />
              </Tabs.Tab>
              {/* Biểu đồ hình tròn */}
              <Tabs.Tab value="PieChart">
                <IconChartDonut3 size={24} />
              </Tabs.Tab>
              {/* table bình thường */}
              <Tabs.Tab value="table">
                <IconTable size={24} />
              </Tabs.Tab>
            </Tabs.List>
          </Group>
        </Flex>
        {/* Hiển thị dạng table  */}
        <Tabs.Panel value="table" style={{ height: `${height}px !important` }}>
          <div style={gridStyle} className={"ag-theme-quartz"}>
            <AgGridReact<any>
              ref={gridRef}
              loading={loading}
              columnDefs={columnDefs}
              defaultColDef={defaultColDef}
              rowModelType={"serverSide"}
              pagination={true}
              paginationPageSize={100}
              paginationPageSizeSelector={paginationPageSizeSelector}
              onSortChanged={handleSortChanged}
              onGridReady={onGridReady}
              getRowId={getRowId}
              getRowStyle={getRowStyle}
              localeText={AG_GRID_LOCALE_VN}
              pinnedBottomRowData={totalRow ? [totalRow] : []}
            />
          </div>
        </Tabs.Panel>
        {/* Hiển thị dạng hình tròn tròn */}
        <Tabs.Panel value="PieChart" style={{ height: `${height + 700}px` }}>
          <Group justify="end" mt="md">
            <Button
              color="teal"
              onClick={() => handleDownloadImage(ChartPieRef)}
            >
              Tải ảnh biểu đồ tròn
            </Button>
          </Group>
          <div
            ref={ChartPieRef}
            style={{
              width: "100%",
            }}
          >
            <Group justify="center" mt={4} mb={8}>
              <span style={{ color: "red", fontSize: 16, fontWeight: "bold" }}>
                * Biểu đồ hiển thị chỉ số "Sau CK/GG (Kỳ này)". Phần trăm (%)
                sau tên đơn vị cho biết tỷ lệ đóng góp của đơn vị đó vào tổng
                giá trị của chỉ số này.
              </span>
            </Group>
            <AgCharts
              options={pieOptions}
              className="chartPie"
              style={{ width: "100%", height: "800px", overflowX: "hidden" }}
            />
          </div>
        </Tabs.Panel>
        {/* Hiển thị dạng dạng cột nằm ngang  */}
        <Tabs.Panel
          value="chartColumn"
          //  style={{ height: `${height + 700}px` }}
          style={{ height: `auto` }}
        >
          <Group justify="end" mt="md">
            <Button
              color="teal"
              onClick={() => handleDownloadImage(ChartColumnRef)}
            >
              Tải ảnh biểu đồ cột
            </Button>
          </Group>
          <div
            ref={ChartColumnRef}
            style={{
              width: "100%",
            }}
          >
            <Group justify="center" mt={4} mb={8}>
              <span style={{ color: "red", fontSize: 16, fontWeight: "bold" }}>
                * Biểu đồ hiển thị chỉ số "Sau CK/GG (Kỳ này)". Phần trăm (%)
                sau tên đơn vị cho biết tỷ lệ đóng góp của đơn vị đó vào tổng
                giá trị của chỉ số này.
              </span>
            </Group>
            <AgCharts
              options={chartOptions}
              className="chart"
              style={{
                width: "100%",
                height: `${heightChartBranchSearch}px`,
                overflowX: "hidden",
              }}
            />
          </div>
          {form.getValues().GroupBy === "BP" && (
            <Group justify="center" mt="md" mb="md">
              {form.getValues().TakeChartColumnBp === "100" ? (
                <>
                  <Button
                    onClick={() => {
                      form.setFieldValue("TakeChartColumnBp", "32");
                      setLoading(true);
                      // reload data theo loại mới
                      gridRef.current?.api?.refreshServerSide?.({
                        purge: true,
                      });
                    }}
                  >
                    Rút gọn
                  </Button>
                </>
              ) : (
                <>
                  <Button
                    onClick={() => {
                      form.setFieldValue("TakeChartColumnBp", "100");
                      setLoading(true);
                      // reload data theo loại mới
                      gridRef.current?.api?.refreshServerSide?.({
                        purge: true,
                      });
                    }}
                  >
                    Xem thêm bộ phận
                  </Button>
                </>
              )}
            </Group>
          )}
        </Tabs.Panel>
      </Tabs>
    </Box>
  );
};
export default SalesByBranch;
